import { getValueOfProp } from "./object-helpers.js";
import { isFunction } from "./function-helpers.js";
/**
 * Creates a duplicate-free version of the specified array, using
 * the iteratee for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur in the array.
 *
 * @param {array} array
 * @param {string|function} iteratee
 * @return {array}
 */
export const filterDuplicates = (array, iteratee) => {
    if (!array || !Array.isArray(array) || !array.length) {
        return array;
    }
    const result = [];
    const seenValues = [];
    array.forEach(item => {
        const value = getValueOfProp(item, iteratee);
        if (!seenValues.includes(value)) {
            seenValues.push(value);
            result.push(item);
        }
    });
    return result;
};
/**
 * Creates an array of numbers (positive and/or negative) progressing from start up to, including, end.
 *
 * @param start
 * @param end
 * @param step
 * @returns {number[]}
 */
export const arrayRange = (start, end, step = 1) => {
    return Array.from({ length: (end - start) / step + 1 }, (value, index) => start + index * step);
};
/**
 * Groups the specified array of object by the specified prop (or callback receiving a prop).
 *
 * @param array
 * @param propOrCallback
 * @returns {*}
 */
export const groupBy = (array, propOrCallback) => {
    return array && Array.isArray(array) ? array.reduce(function (accumulator, currentValue) {
        const groupValue = isFunction(propOrCallback) ? propOrCallback(currentValue) : currentValue[propOrCallback];
        (accumulator[groupValue] = accumulator[groupValue] || []).push(currentValue);
        return accumulator;
    }, {}) : {};
};
/**
 * Joins the values of the specified array with the specified separator allowing the
 * last value to be separated by an individual separator.
 *
 * @param {array} array
 * @param {string} separator
 * @param {string} lastSeparator
 * @returns {string}
 */
export const join = (array, separator = ', ', lastSeparator = ', ') => {
    if (!array.length) {
        return '';
    }
    if (array.length === 1) {
        return array[0];
    }
    return array.slice(0, -1).join(separator) + lastSeparator + array.slice(-1);
};
//# sourceMappingURL=array-helpers.js.map